module.exports = __webpack_public_path__ + "static/media/vst.b1c34600.jpg";